<template>
  <div class="detail_main bg_detail is-scrollable has-background-white">
    <div class="detail_img_info">
      <a
        class="button has-text-white is-rounded diapo_button"
        @click="$parent.show = false">
        <span class="icon">
          <b-icon
            icon="chevron-left">
          </b-icon>
        </span>
        <label>Retour</label>
      </a>
      <img :src="url" class="imageBgOpp imgGoToTop">
    </div>
    <div class="leftVert topViolet rightVert bottomVert">
      <div class="tabs bottomVert">
        <ul class="p_size12 has-text-weight-bold">
          <li :class="{'underline is-active': active === 1}"
              @click="active = 1"
              class="is-paddingless">
            <a>Proposition</a>
          </li>
          <li :class="{'underline is-active': active === 2}"
              @click="active = 2"
              class="is-paddingless">
            <a>Caractéristiques</a>
          </li>
          <li :class="{'underline is-active': active === 3}"
              @click="active = 3"
              class="is-paddingless">
            <a>Visibilité</a>
          </li>
        </ul>
      </div>
      <div v-if="active === 1">
        <div class="columns is-mobile is-multiline is-marginless color-icon">
          <div
            v-if="detailFaceLc.extensionOpportunite.duree"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Durée
                  </label><br>
                  <strong class="p_size12 has-text-weight-bold has-text-link">
                    {{detailFaceLc.extensionOpportunite.duree}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceLc.extensionOpportunite.tarifAnnuel"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cash"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-grey">
                    Tarif Brut HT
                  </label><br>
                  <strong class="p_size14 has-text-link">
                    {{formatNum(this.detailFaceLc.extensionOpportunite.tarifAnnuel)}}
                    {{this.detailFaceLc.extensionOpportunite.tarifInformation}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceLc.extensionOpportunite.tarifNet"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cash"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-grey">
                    Tarif Net HT
                  </label><br>
                  <strong class="p_size14 has-text-link">
                    {{formatNum(this.detailFaceLc.extensionOpportunite.tarifNet)}}
                    {{this.detailFaceLc.extensionOpportunite.tarifInformation}}
                  </strong>
                  <br>
                  <span class="has-text-grey is-italic"
                    v-if="detailFaceLc.extensionOpportunite.masquerRemiseEdition === true
                      && this.detailFaceLc.extensionOpportunite.remise">
                    {{this.detailFaceLc.extensionOpportunite.remise}} {{typeRemise}}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceLc.extensionOpportunite.fraisTechnique"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="cash-refund"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Frais techniques HT
                  </label><br>
                  <strong class="p_size12 has-text-link">
                    {{fraisTechnique}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceLc.extensionOpportunite.taxeMunicipale"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="ballot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Taxes municipales
                  </label><br>
                  <strong class="p_size12 has-text-link">
                    {{taxeMunicipale}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFaceLc.extensionOpportunite.tarifDePose"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <small class="has-text-default">
                    Frais de pose HT
                  </small><br>
                  <strong class="p_size12 has-text-link">
                    {{tarifDePose}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="dateDisponibilite"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="calendar-check"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Date de début
                  </label><br>
                  <strong class="p_size12 has-text-link">
                    {{dateDisponibilite}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="dateFin"
            class="column bottomViolet is-paddingless is-6">
            <div class="media">
              <b-icon
                icon="calendar-check"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Date de fin
                  </label><br>
                  <strong class="p_size12 has-text-link">
                    {{dateFin}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="detailFaceLc.extensionOpportunite.commentaire">
          <p
            class="p_size12 has-text-link has-text-weight-bold topViolet bottomViolet">
            Commentaire:
          </p>
          <div class="">
            <p class="has-text-link has-text-justify p_size11">
              {{detailFaceLc.extensionOpportunite.commentaire}}
            </p>
          </div>
        </div>
      </div>
      <div v-if="active === 2">
        <div class="columns is-mobile is-marginless is-multiline color-icon">
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="barcode"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Code face
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{codeFaces}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="panorama-wide-angle"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Panneau
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{detailFaceLc.code}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Format
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{detailFaceLc.format}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="package-variant-closed"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Matériel
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{detailFaceLc.materiel}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Support
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{detailFaceLc.support}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="lightbulb-on-outline"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Éclairé
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{eclaire}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="active === 3">
        <div class="columns is-mobile is-marginless is-multiline color-icon">
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="map-marker-circle"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Localisation
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{detailFaceLc.localisation ?
                      detailFaceLc.localisation :
                      'Non renseignée'}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="angle-obtuse"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Angle de vision
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{detailFaceLc.angleDeVision ?
                      detailFaceLc.angleDeVision :
                      'Non renseignée'}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="arrow-right"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    En venant de
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{detailFaceLc.enVenantDe ?
                      detailFaceLc.enVenantDe :
                      'Non renseignée'}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet is-6">
            <div class="media">
              <b-icon
                icon="arrow-left"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    En allant vers
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{detailFaceLc.enAllantVers ?
                      detailFaceLc.enAllantVers :
                      'Non renseignée'}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="column is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="map-marker"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content">
                <p class="is-size-7">
                  <label class="has-text-default">
                    Adresse
                  </label><br>
                  <strong class="p_size10 has-text-link">
                    {{adresse}}
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!detailFaceLc.select" @click="contolSelect()"
         class="navbar is-fixed-bottom button is-primary
                boutonSelectM has-text-weight-bold">
      <p class="p_size11 centreM">Ajouter a ma sélection</p>
    </div>
    <div v-else @click="contolSelect()"
         class="navbar is-fixed-bottom button boutonRed boutonSelectM has-text-weight-bold">
      <p class="p_size11 centreM">Retirer de ma sélection</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import { formatNum, urlPhoto, formatDate, formatCodeFace, formatEclaire, formatAdresse } from '@/services/opportunite/formatTab';

export default {
  name: 'detailOpportunites',
  props: ['detailFaceLc'],
  data() {
    return {
      active: 1,
      select: true,
    };
  },
  computed: {
    tarifAnnuel() {
      return formatNum(this.detailFaceLc.extensionOpportunite.tarifAnnuel);
    },
    fraisTechnique() {
      return formatNum(this.detailFaceLc.extensionOpportunite.fraisTechnique);
    },
    taxeMunicipale() {
      return formatNum(this.detailFaceLc.extensionOpportunite.taxeMunicipale);
    },
    tarifDePose() {
      return formatNum(this.detailFaceLc.extensionOpportunite.tarifDePose);
    },
    dateDisponibilite() {
      return formatDate(this.detailFaceLc.extensionOpportunite.dateDisponibilite);
    },
    dateFin() {
      return formatDate(this.detailFaceLc.extensionOpportunite.dateFin);
    },
    codeFaces() {
      return formatCodeFace(this.detailFaceLc.codeFaces);
    },
    eclaire() {
      return formatEclaire(this.detailFaceLc.eclaire);
    },
    adresse() {
      return formatAdresse(this.detailFaceLc);
    },
    url() {
      return urlPhoto(this.detailFaceLc.extensionOpportunite.urlPhoto);
    },
    typeRemise() {
      if (this.detailFaceLc.extensionOpportunite.typeDeRemise === 0) {
        return '% de remise inclus';
      }
      return '€ de remise inclus';
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let fraisTechnique = 0;
      if (this.detailFaceLc.extensionOpportunite.tarifDePose) {
        tarifDePose = this.detailFaceLc.extensionOpportunite.tarifDePose;
      }
      if (this.detailFaceLc.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = this.detailFaceLc.extensionOpportunite.taxeMunicipale;
      }
      if (this.detailFaceLc.extensionOpportunite.fraisTechnique) {
        fraisTechnique = this.detailFaceLc.extensionOpportunite.fraisTechnique;
      }
      if (this.detailFaceLc.extensionOpportunite.tarifNet) {
        tarifNet = this.detailFaceLc.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
      }
      return this.detailFaceLc.extensionOpportunite.tarifAnnuel
        + tarifDePose
        + taxeMunicipale
        + fraisTechnique;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.detailFaceLc.select = !this.detailFaceLc.select;
      if (this.detailFaceLc.select) {
        this.detailFaceLc.icon = iconColorGetter('#49db70', TAILLE_ICON_GRAND);
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.detailFaceLc.icon = iconColorGetter('#009ce0', TAILLE_ICON_GRAND);
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    formatNum(data) {
      return formatNum(data);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = 'hidden';
    test2.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    const test2 = document.querySelector('body');
    test.style.overflow = '';
    test2.style.overflow = '';
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/panneauxLc/detailOpportunites.vue